import { render, staticRenderFns } from "./PageConfigAdmin.vue?vue&type=template&id=c9a9aefa&scoped=true"
import script from "./PageConfigAdmin.vue?vue&type=script&lang=js"
export * from "./PageConfigAdmin.vue?vue&type=script&lang=js"
import style0 from "./PageConfigAdmin.vue?vue&type=style&index=0&id=c9a9aefa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a9aefa",
  null
  
)

export default component.exports